<template>
    <div
    ref="modalgbp"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    >
        <div
        class="modal-dialog modal-dialog-centered"
        :class="tamano ? tamano : ''"
        role="document"
        >
            <div class="modal-content">
                <div class="modal-header f-20 f-500">
                    {{ titulo }}
                    <!-- <img v-if="icon" class="img-tipo" width="88" :src="`/img/modales/${icon}.svg`" alt="" /> -->
                    <div class="ml-auto my-auto d-middle-center bg-white rounded-circle" style="width:20px;height:20px;">
                        <i class="icon-close f-13 cr-pointer" data-dismiss="modal" />
                    </div>
                </div>
                <div class="border-modal-top"></div>
                
                <div class="modal-body overflow-auto custom-scroll" style="max-height:70vh;">
                    <!-- <div class="row my-3 mt-5 text-muted f-17 f-600 justify-center text-center px-3">
                        {{ titulo }}
                    </div> -->
                    <slot />
                </div>
                <div class="border-modal-bottom"></div>
                <div class="row mx-0 justify-content-end py-2">
                    <button
                    v-show="btnCancelar"
                    type="button"
                    class="btn mx-2 btn-cerrar f-300 f-14 br-4 border f-300"
                    @click="cancelar"
                    v-text="textosBotones.cancelar"
                    />
                    <button
                    v-show="aceptar"
                    v-loading="cargando"
                    type="button"
                    class="btn mx-2 f-14 btn-aceptar f-300 text-white br-4 f-300"
                    @click="actionAceptar"
                    v-text="textosBotones.aceptar"
                    />
                    <button
                    v-show="eliminar"
                    v-loading="cargando"
                    type="button"
                    class="btn mx-2 f-14 btn-danger f-300"
                    @click="actionEliminar"
                    v-text="textosBotones.eliminar"
                    />
                    <button
                    v-show="listo"
                    v-loading="cargando"
                    type="button"
                    class="btn mx-2 f-14 btn-general f-300"
                    @click="toggle"
                    v-text="textosBotones.listo"
                    />
                    <button
                    v-show="adicional !== ''"
                    v-loading="cargando"
                    :disabled="desactivarGuardar"
                    type="button"
                    class="btn mx-2 f-14 btn-general f-300"
                    @click="onAdicional"
                    v-text="adicional"
                    />
                    <button
                    v-for="btn in btns"
                    v-show="btns.length"
                    :key="btn.texto"
                    type="button"
                    class="btn mx-2 f-14 f-300"
                    :class="btn.color"
                    @click="$emit('accion', btn.accion)"
                    v-text="btn.texto"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        titulo: {
            type: String,
            required: true
        },
        tamano: {
            type: String,
            default: 'modal-md'
        },
        listo: {
            type: Boolean,
            default: false
        },
        eliminar: {
            type: Boolean,
            default: false
        },
        aceptar: {
            type: Boolean,
            default: false
        },
        desactivarGuardar: {
            type: Boolean,
            default: false
        },
        adicional: {
            type: String,
            default: ''
        },
        btns: {
            type: Array,
            default: () => { return [] }
        },
        cargando: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: ''
        },
        btnCancelar:{
            type: Boolean,
            default: true
        }
    },
    data(){
        return {
            textosBotones: {
                listo: 'Listo',
                aceptar: 'Aceptar',
                guardar: 'Guardar',
                eliminar: 'Eliminar',
                cancelar: 'Cerrar'
            }
        }
    },
    methods: {
        toggle(){
            $(this.$refs.modalgbp).modal('toggle')
        },
        guardar(){
            this.$emit('guardar')
        },
        actionEliminar(){
            this.$emit('eliminar')
        },
        actionAceptar(){
            this.$emit('aceptar')
        },
        onAdicional(){
            this.$emit('adicional')
        },
        cancelar(){
            this.$emit('cancelar')
            this.toggle()
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~/sass/gbp.scss';

.modal-content{
    border: none;
    border-radius: 8px;
    .border-modal{
        &-top{
            width: 100%;
            height: 1px;
            background: linear-gradient(to right, #E3E3E3, #FFFFFF00);
        }
        &-bottom{
            width: 100%;
            height: 1px;
            background: linear-gradient(to left, #E3E3E3, #FFFFFF00);
        }
    }
    .modal-header{
        // background:linear-gradient( rgba(50,163,253,.65) 1% , rgba(255,255,255,1) , rgba(255,255,255,1), rgba(255,255,255,1) );
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-bottom: none;
        background-size: cover;
        padding: 0.6rem 1rem;

        .close{
            outline: none;
            transition-duration: .85s;
            position: absolute;
            right: 10px;
            top: 1px;
            font-size: 2.5em;

            &:hover{
                transition-duration: .4s;
                transform: rotate(360deg) scale(1.2);
            }
        }
        .logo{
            display: block;
            // height: 70px;
            // width: 70px;

            span{
                font-size: 1.2em;
            }
        }
       
    }
    .modal-title{
        color: $azul2-primary;
        font-weight: normal;
    }
}
.img-tipo{
    position: absolute;
    top:20px;
    left: 50%;
    transform: translate(-50%);
}
.btn{
    &-cerrar{
        width: 94px;
    }
    &-general{
        width: 94px;
    }
}

 
</style>
